// extracted by mini-css-extract-plugin
export default {"container":"NativeAppsLink_container--YgO","linkContainer":"NativeAppsLink_linkContainer--tab","tabletFooter":"NativeAppsLink_tabletFooter--xiT"};